<template>
  <div class="cm-acc-invoice-contact selectedInvoice-info dbox">
    <div class="ut-h-full2" style="margin-top: 1px">
      <TextField2
        id="invoice_address"
        :label="$t('invoice_address')"
        :placeholder="$t('invoice_address')"
        :textarea="true"
        :height="115"
        :bb="'0px'"
        :disabled="selectedCostsDetails.disabled"
        :value="selectedCostsDetails.invoice.invoice_address"
        :placeholderHTML="true"
        @change="onTextFieldValueChange"
      >
        <template #placeholderHTML>
          <div ref="placeholderHTML" v-html="invoiceAddressHTML"></div>
        </template>
      </TextField2>
      <!-- <div style="display: flex; border-bottom: 1px solid var(--sprt-85)">
        <TextField2
          id="vat_id"
          :label="$t('vat_id')"
          :disabled="selectedCostsDetails.disabled"
          :value="selectedCostsDetails.contact.vat_no"
          :bb="'0px'"
          :cw="`clamp(140px, ${
            (
              (selectedCostsDetails.contact &&
                selectedCostsDetails.contact.vat_no) ||
              ''
            ).toString().length * 12
          }px, 250px)`"
          @change="onVatIDUpdate"
          :style="{
            '--fc2-tf-margin-focus': '-1px 3px -1px 0px',
          }"
        />
        <div class="fcc">
          <div class="loading-icon" v-if="vatIdValidityLoading">
            <img src="static/icons/loading.gif" alt />
          </div>
          <div
            v-if="vat_button && !vatIdValidityLoading"
            :class="`status-button ${this.vatIdValidity ? 'valid' : 'invalid'}`"
            @click="onVatIDClick"
          >
            {{ this.vatIdValidity ? "Valid" : "Invalid" }}
          </div>
        </div>
      </div> -->
    </div>
    <div class="dbox-title-bar--options">
      <div class="ut-flex ut-link ut-text-accent5">
        <img
          @click="onAssignContactClick"
          src="static/icons/lupe.svg"
          class="dt-icon v5 s2"
          :alt="$t('assign_contact')"
          :title="$t('assign_contact')"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { AccountingStoreNamespace as storeNS } from "../../store";
import * as ActionTypes from "../../store/types";
import { mapActionObject, mapGetterObject } from "../../../../store/global";
import { costsActions } from "../../store/costs/actions";
import { EventHooks } from "../../../../plugins/text-field";
import DatePicker from "@plugins/text-field/date-picker";
import { contactListLDTRoutes } from "../../../contacts/router/routes";
import { encodeRoute } from "../../../../utility";
import { NotificationService } from "../../../../dt-plugins/notification/notification.service";
import { checkVATNumber } from "../../../contacts/models/vat.model";

export default {
  components: {
    DatePicker,
  },
  props: {
    selectedCostsDetails: {
      required: true,
    },
  },
  data: function () {
    return {
      textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: false,

        validationEvent: EventHooks.OnBlur,
        valueChangedEvent: EventHooks.OnBlur,
      },
    };
  },
  computed: {
    vatIdValidity: function () {
      return this.selectedCostsDetails.check_vat_id == "1";
    },
    vat_button: function () {
      return this.selectedCostsDetails.vat_button == "1";
    },
    vatIdValidityLoading: function () {
      return (
        this.selectedCostsDetails &&
        this.selectedCostsDetails.vatIdValidityLoading
      );
    },
    invoiceAddressHTML: function () {
      const contact_id = this.selectedCostsDetails.invoice.contact_id;
      console.log( this.selectedCostsDetails);
      let htm =
        this.selectedCostsDetails?.invoice?.invoice_address?.split?.("\n");
      if (!htm) {
        return;
      }
      htm[0] = `<a class="contact-link"><b>${htm[0]}</b></a>`;

      this.$nextTick(() => {
        this.$refs["placeholderHTML"]
          ?.querySelector?.(".contact-link")
          ?.addEventListener?.("click", () => {
            this.$router.push({
              name: contactListLDTRoutes.names.details,
              params: {
                contact_id,
              },
              query: {
                from: encodeRoute(this.$route),
              },
            });
          });
      });

      return htm.join("<br >");
    },
  },
  methods: {
      ...mapActionObject(storeNS, costsActions),
    onTextFieldValueChange: function ({ name, value }) {
      this.$emit("changed", {
        name,
        value,
      });
    },
    onPerformanceDateUpdate: function (name, value) {
      // console.log(name, value);
      this.$emit("changed", {
        name,
        value,
      });
    },
    onVatIDClick: function () {
      checkVATNumber(this.selectedCostsDetails.contact.vat_no || "");
    },
    onVatIDUpdate: function ({ name, value }) {
      this.$emit("vat_update", {
        name,
        value,
      });
    },
    onAssignContactClick: function (event) {
      console.log("item", this.selectedCostsDetails);
      const lock_flag =
        this.selectedCostsDetails?.invoice?.lock_flag || undefined;
      if (
        lock_flag == null ||
        lock_flag == "0" ||
        lock_flag == undefined ||
        lock_flag == ""
      ) {
        this.$router.push({
          ...this.$route,
          query: {
            modal: "add_invoice_contact",
          },
        });
      } else if (lock_flag == "1") {
        NotificationService.showNotification({
          text: "Must Unlock Invoice To Edit Contact",
          timeout: 5000,
        });
      }
    },

    //MARK: METHODS
  },
};
</script>

<style lang="scss">
.cm-acc-invoice-contact {
  .contact-link {
    text-decoration: none;
    color: var(--text-primary);
    &:hover {
      text-decoration: underline;
    }
  }
  .fc-control {
    &.placeholderHTML {
      overflow: auto;
    }
  }
}
</style>
